import { types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'

const _ADSRStore = types
  .model({
    attack: 0.01,
    decay: 0.5,
    sustain: 0.3,
    release: 0.5
  })
  .actions((self) => {
    return {}
  })

interface ADSRStoreType extends ForDirectExtend<typeof _ADSRStore> {}
export const ADSRStore: ADSRStoreType = _ADSRStore
